/* eslint-disable no-underscore-dangle */
/* eslint-disable arrow-parens */
/* eslint-disable max-len */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Badge,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
  Button, 
  Modal, 
  ModalHeader, 
  ModalBody, 
  ModalFooter,
} from 'reactstrap';
import { RTLProps } from '@/shared/prop-types/ReducerProps';
import { useQuery } from 'react-query';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { useHistory } from 'react-router';

const Transporter = ({ rtl }) => {
  const { t } = useTranslation('common');
  const [cookies, setCookie] = useCookies(['tranAuthToken']);
  const [modal, setModal] = useState(false);
  const [emailToBeDeleted, setemailToBeDeleted] = useState('');
  const toggle = () => setModal(!modal);

  const {
 data, isLoading, isFetching, isError,
} = useQuery(
    'allTransporters',
    () => axios.get(
        'https://orca-app-5i5qx.ondigitalocean.app/api/admin/transporter/list',
        {
          headers: {
            Authorization: `Bearer ${cookies.tranAuthToken}`,
          },
        },
      ),
  );
  if (data && !isLoading && !isFetching && !isError) {
    console.log('transporter', data.data);
  }

    function gettingEmailForDeleting(email) {
      setemailToBeDeleted(email);
  }

  async function deletingUser(email) { 
    const emailData = JSON.stringify({
      email: `${email}`,
    });
  
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://orca-app-5i5qx.ondigitalocean.app/api/admin/delete/user',
      headers: { 
        Authorization: `Bearer ${cookies.tranAuthToken}`, 
        'Content-Type': 'application/json',
      },
      data: emailData,
    };

    await axios(config).then(response => {
      if (response.data === 'success') {
        // console.log(response.data);
        window.location.reload();
      }
    }).catch((error) => console.log(error));
  }

  const history = useHistory();

  // console.log('data trans', data.data);

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          {/* <h3 className="page-title">{t('booking_dashboard.page_title')}</h3> */}
          <h3 className="page-title">Transporter</h3>
        </Col>
      </Row>
      <Row>
        <Col md={12} lg={12}>
          <Card>
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">All Transporter Table</h5>
                {/* <h5 className="subhead">Use default table with property
                  <span className="red-text">responsive
                  </span>
                </h5> */}
              </div>
              <Table responsive hover className="table--bordered">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>User Name</th>
                    {/* <th>Admin Name</th> */}
                    <th>Company Name</th>
                    <th>Address</th>
                    <th>Contact</th>
                    <th>Email</th>
                    {/* <th>GST No.</th> */}
                    {/* <th>Location</th> */}
                    <th>PAN No.</th>
                    <th>Pin Code</th>
                    <th>Time </th>
                    <th>Truck Count</th>
                    <th>Routes</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {isFetching && (
                    <tr>
                      <td>Loading...</td>
                    </tr>
                  )}
                  {!isLoading
                    && !isFetching
                    && !isError
                    && data
                    && data.data
                    && data.data.list
                    && data.data.list.map((item, index) => (
                      <tr key={item._id}>
                        <td>{index + 1}</td>
                        <td>{item.userName}</td>
                        {/* <td>{item.adminName}</td> */}
                        <td>{item.companyName}</td>
                        <td>{item.address}</td>
                        <td>{item.contact}</td>
                        <td>{item.email}</td>
                        {/* <td>{item.gstNumber}</td> */}
                        {/* <td>{item.location}</td> */}
                        <td>{item.panNumber}</td>
                        <td>{item.pincode}</td>
                        <td>
                          {new Date(
                            item.createdAt,
                          ).toLocaleDateString()}
                        </td>
                        <td>{item.truckCount}</td>
                        {/* <td> <Button size="sm" outline onClick={() => history.push(`/transporter/routes/${index}`)}>View Routes</Button> </td> */}
                        <td>
                          <Badge
                            color="success"
                            onClick={() => history.push(
                                `/transporter/routes/${index}`,
                              )}
                          >
                            View Routes
                          </Badge>
                        </td>
                        <td>{item.status ? <p style={{ fontWeight: 'bold' }}>True</p> : <p style={{ fontWeight: 'bold' }}>False</p>}</td>
                        <td>{item.status ? <Badge onClick={() => { gettingEmailForDeleting(item.email); toggle(); }} color="danger" size="sm">Delete</Badge> : <Badge disabled color="secondary" size="sm">Delete</Badge>}</td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>User Deletion</ModalHeader>
        <ModalBody> 
          Do you want to delete {emailToBeDeleted}?
        </ModalBody>
        <ModalFooter cssModule={{ justifyContent: 'center' }}>
          <Button color="primary" onClick={() => { deletingUser(emailToBeDeleted); toggle(); }}>
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
};

Transporter.propTypes = {
  rtl: RTLProps.isRequired,
};

export default connect((state) => ({
  rtl: state.rtl,
}))(Transporter);
